import { render, staticRenderFns } from "./RegistrationAndLoginError.vue?vue&type=template&id=8a58b82c&"
import script from "./RegistrationAndLoginError.vue?vue&type=script&lang=js&"
export * from "./RegistrationAndLoginError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports